/**
 * Constantes des points d'intérêt (familles, types, couleurs, emojis, labels).
 * Source de vérité UI, alignée sur le backend (poi.service.ts / migration 175).
 */

export type PoiFamille = 'securite' | 'entraide' | 'tourisme';

export const POI_FAMILLE_LABEL: Record<PoiFamille, string> = {
  securite: 'Sécurité',
  entraide: 'Entraide',
  tourisme: 'Tourisme',
};

/** Couleur par famille (OKLCH → hex approx pour Leaflet/inline). */
export const POI_FAMILLE_COLOR: Record<PoiFamille, string> = {
  securite: '#e5484d',   // rouge
  entraide: '#1d9e88',   // teal GRC
  tourisme: '#e0a020',   // ambre
};

export const POI_TYPES_PAR_FAMILLE: Record<PoiFamille, string[]> = {
  securite: ['dae', 'rassemblement_pcs', 'abri_fraicheur', 'eau_potable'],
  entraide: ['boite_dons', 'boite_livres', 'composteur', 'borne_recharge',
             'jardin_partage', 'toilettes', 'wifi_public', 'parking'],
  tourisme: ['monument', 'musee', 'point_vue', 'site_remarquable', 'sentier'],
};

export const POI_TYPE_LABEL: Record<string, string> = {
  dae: 'Défibrillateur',
  rassemblement_pcs: 'Point de rassemblement',
  abri_fraicheur: 'Abri / point de fraîcheur',
  eau_potable: 'Point d’eau potable',
  boite_dons: 'Boîte à dons',
  boite_livres: 'Boîte à livres',
  composteur: 'Composteur partagé',
  borne_recharge: 'Borne de recharge',
  jardin_partage: 'Jardin partagé',
  toilettes: 'Toilettes publiques',
  wifi_public: 'Point wifi public',
  parking: 'Parking',
  monument: 'Monument',
  musee: 'Musée',
  point_vue: 'Point de vue',
  site_remarquable: 'Site remarquable',
  sentier: 'Sentier / balade',
  autre: 'Autre',
};

export const POI_TYPE_EMOJI: Record<string, string> = {
  dae: '♥', rassemblement_pcs: '⚑', abri_fraicheur: '❄', eau_potable: '💧',
  boite_dons: '🎁', boite_livres: '📚', composteur: '♻', borne_recharge: '⚡',
  jardin_partage: '🌱', toilettes: '🚻', wifi_public: '📶', parking: 'P',
  monument: '🏛', musee: '🖼', point_vue: '👁', site_remarquable: '⭐', sentier: '🥾',
  autre: '📍',
};

/** Famille d'un type (pour retrouver la couleur d'un point). */
export function familleDuType(type: string): PoiFamille {
  for (const fam of Object.keys(POI_TYPES_PAR_FAMILLE) as PoiFamille[]) {
    if (POI_TYPES_PAR_FAMILLE[fam].includes(type)) return fam;
  }
  return 'entraide';
}
